import IPassword, { IKeyVal } from "../shared/Password";
import PassApi from "../data/PassApi";
import PropertyListEdit from "./PropertyListEdit";
import { useState } from "react";
import PropertyList from "./PropertyList";
import useConfirm from "../gui/Dialogs/Confirm";
import IconButton from "../gui/Button/IconButton";
import EditIcon from "../gui/Icons/EditIcon";
import SaveIcon from "../gui/Icons/SaveIcon";
import DeleteIcon from "../gui/Icons/DeleteIcon";
import ChevronRight from "../gui/Icons/ChevronRight";
import { useSnackbar } from "../gui/Snackbar/SnackbarProvider";

export default function PasswordRow(props:{password:IPassword}) {
    const {password} = props
    const [open,setOpen] = useState<boolean>(false)
    const [edit,setEdit] = useState<boolean>(false)
    const [data,setData] = useState<IKeyVal[]>(password.data.map(keyval => ({key:keyval.key,val:keyval.val})))
    const {confirm} = useConfirm()
    const {addSnackbar} = useSnackbar()

    const onYes = async () => {
        try {
            await PassApi.i.delete(password.id)
        }catch(e){
            addSnackbar(e)
        }
    }
    const onDelete = () => confirm({msg:`Are you sure you wish to delete ${password.name}`,onYes})
    const onUpdateProp = (index:number,key:string,val:string) => setData(data => {
        const active = document.activeElement
        active instanceof HTMLInputElement && setTimeout(() => active?.focus())
        data[index] = {key,val}
        return [...data]
    })
    const onAdd = () => setData(data => [...data,{key:"",val:""}])

    const onDeleteProp = async (index:number) => {
        data.splice(index, 1)
        setData([...data])
    }
    const onSave = async () => {
        try {
            const filtered = data.filter(r => !!r.key)
            await PassApi.i.update(password.id, filtered)
            setData(filtered)
            setEdit(false)
            return true
        }catch(e){
            addSnackbar(e)
            return false
        }
    }
    const onEdit = () => {
        if (!open) setOpen(true)
        setEdit(true)
    }
    const toggle = async () => {
        if (open && edit) onSave()
        else setOpen(!open)        
    }
    const className = "row" + (open ? " open" : "")
    const propertyList = open ? 
        (edit ? <PropertyListEdit passwordId={password.id} data={data} onAdd={onAdd} onUpdate={onUpdateProp} onDelete={onDeleteProp}/> : <PropertyList data={data}/>)
        : null
    return <div className={className}>
        <div className="name flex middle" key={password.id}>
            <div className="name flex1" onClick={toggle}>{password.name}</div>
            {edit ? null : <IconButton onClick={onEdit}><EditIcon/></IconButton>}
            {edit ? <IconButton onClick={onSave}><SaveIcon/></IconButton> : null}
            <IconButton onClick={onDelete}><DeleteIcon/></IconButton>
            <IconButton onClick={toggle} className="arrow"><ChevronRight/></IconButton>
        </div>
        {propertyList}
    </div>
}
    